<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Zone löschen ?"
                @ok="submit" ok-text="Fortfahren" :loading="loading"
                @cancel="cancel">
            Soll die Zone <b>{{ zoneName }}</b> mit der ZoneID <b>{{ data ? data.ZoneId : null }}</b>
            wirklich gelöscht werden? <br><br>
            Diese Aktion kann nicht mehr rückgängig gemacht werden.
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Zone <b> {{ zoneName }} </b> erfolgreich gelöscht.
        </Snackbar>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Snackbar from "../../../components/Snackbar";
import Utils from "../../../scripts/Utils";

export default {
    name: "DeleteZoneDialog",
    components: {Snackbar, Dialog},
    props: ['value', 'data'],
    data: () => {
        return {
            loading: false,
            successSnackbar: false
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        selectedSite() {
            return this.vuexState.selectedSite;
        },
        siteName() {
            return this.selectedSite ? this.selectedSite.Name : '';
        },
        zoneName() {
            return this.data ? Utils.parseZoneName(this.data.Name) : '';
        }
    },
    methods: {
        async submit() {
            this.loading = true;
            let data = await this.$store.dispatch('zones/deleteZone', this.getBody());
            if (data.Status) {
                this.successSnackbar = true;
                this.$emit('input', false); // set v-model to false -> close dialog
            }
            this.loading = false;
        },
        getBody() {
            return {
                site_id: this.vuexState.selectedSite.SiteId,
                publisher_id: this.vuexState.selectedSite.PublisherId,
                type_id: this.data.SitetypeId,
                zone_id: this.data.ZoneId,
            }
        },
        cancel() {
            if (this.loading) {
                this.$store.commit('zones/cancelRequest', 'deleteZone');
                this.loading = false;
            }
            this.$emit('input', false);
        }
    },
}
</script>

<style scoped>

</style>